import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogActions } from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate } from 'react-router-dom';

export default function BillingWarningModal() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const isUnpaid = sessionStorage.getItem('BillingWarning');
    if (isUnpaid === 'true') {
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleNavigateBilling = () => {
    handleClose();
    navigate('/Home/labs-Billing');
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        className: 'common-bg-white common-box-shadow common-br-3px border-0 overflow-hidden',
        style: { borderRadius: '8px' }
      }}
    >
      {/* Top Banner Accent */}
      <div className="bg-warning text-white p-3 d-flex align-items-center gap-2">
        <div className="bg-white rounded-circle p-1 d-flex align-items-center justify-content-center">
          <WarningAmberRoundedIcon className="text-warning" fontSize="medium" />
        </div>
        <div className="common-FontFamily">
          <h6 className="commont-Font-Bold m-0 text-white common-FontSize-small">
            Payment Required / ادائیگی لازمی ہے
          </h6>
        </div>
      </div>

      <DialogContent className="p-4">
        {/* English Message */}
        <div className="mb-3 border-bottom pb-3">
          <p className="common-FontFamily common-FontSize-small text-dark mb-0 leading-normal">
            Your laboratory subscription payment is currently pending. Please complete your payment under{' '}
            <span className="common-Link commont-Font-Bold" onClick={handleNavigateBilling}>
              Billing
            </span>{' '}
            to continue using all system features without interruption.
          </p>
        </div>

        {/* Urdu Message */}
        <div className="common-text-end" dir="rtl">
          <p
            className="common-FontFamily common-FontSize-small text-secondary mb-0"
            style={{ fontFamily: 'Noto Nastaliq Urdu, Tahoma, sans-serif', lineHeight: '1.8' }}
          >
            آپ کی لیبارٹری کی سبسکرپشن ادائیگی بقیہ ہے۔ تمام سروسز کو بغیر کسی رکاوٹ کے جاری رکھنے کے لیے برائے مہربانی{' '}
            <span className="common-Link commont-Font-Bold" onClick={handleNavigateBilling}>
              بلنگ (Billing)
            </span>{' '}
            سیکشن میں جا کر اپنی ادائیگی مکمل کریں۔
          </p>
        </div>
      </DialogContent>

      <DialogActions className="p-3 bg-light d-flex justify-content-between align-items-center border-top">
        <button
          type="button"
          onClick={handleNavigateBilling}
          className="common-button common-setting-button common-FontFamily d-flex align-items-center justify-content-center gap-1"
          style={{ width: 'auto', padding: '6px 12px', backgroundColor: '#0d6efd' }}
        >
          <CreditCardIcon style={{ fontSize: '14px' }} />
          Pay Now
        </button>

        <button
          type="button"
          onClick={handleClose}
          className="common-button common-setting-button common-FontFamily"
        >
          I Understand
        </button>
      </DialogActions>
    </Dialog>
  );
}